import { CCol, CRow } from '@coreui/react-pro';
import React from 'react';
import { CART_TYPES } from '../../../../../constants';
import TrainingCourse from '../TrainingSeatDetails/TrainingCourse';

const Bundle = ({ product }) => {
     const headline = product.pageOrgHeadline;

     const subHeadline = product.pageOrgSubHeadline;

     const bodyText = product.pageOrgBodyText;

     return (
          product && (
               <div className="online-course-detail" key={product.id}>
                    <div className="detail-course-org">
                         <div className="header-course-org">
                              <div className="content-course-org">
                                   <h3>{headline}</h3>

                                   <div className="training-intro-short-description">
                                        <p className="purchase" dangerouslySetInnerHTML={{ __html: subHeadline }} />
                                   </div>

                                   <div className="training-intro-description">
                                        <p className="text-editor" dangerouslySetInnerHTML={{ __html: bodyText }} />
                                   </div>
                              </div>
                         </div>
                         <CRow>
                              <CCol>
                                   {[CART_TYPES.ORGANIZATION, CART_TYPES.BOTH].includes(product.purchaseType) && <TrainingCourse product={product} />}
                              </CCol>
                         </CRow>
                    </div>
               </div>
          )
     );
};
export default Bundle;
